import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      container: {
        padding: '4px 0',
      },
      subTitle: {
        fontSize: '16px',
        fontFamily: 'Nunito',
        paddingBottom: '12px',
        paddingTop: '12px'
      },
      itemEleicao: {
        backgroundColor: '#F8F9F7',
        height: '46px',
        padding: '10px',
        marginBottom: '8px',
        borderRadius: '4px'
      },
      itemText: {
        fontSize: '16px',
        fontFamily: 'Nunito'
      }
    }),
  {
    name: 'PautaEleicaoModal',
  }
);
